export default __webpack_public_path__ + "static/media/006-champagne.ff98ab6a.svg";